import * as confirmAction from "../../../../store/confirm/action";
import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Col, Modal } from "reactstrap";
import {
  GET_DT_COMPOSITION,
  GET_DT_COMPOSITION_COLUMN,
  GET_DT_COMPOSITION_ROW,
  GET_GC_GROUP,
  LOAD_GAS_COMPOSITON,
  SAVE_DT_COMPOSITION,
  SAVE_DT_COMPOSITION_COLUMN,
  SAVE_DT_COMPOSITION_ROW
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { getPermission } from "../../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";
import { values } from "redux-form";

function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}


function GasComposition(props) {
  const dispatch = useDispatch();
  const permission = getPermission();
  //   const [dateSelected, setDateSelected] = useState(props.dateSelected);
  const [dateNow, setDateNow] = useState(moment(new Date()).format("YYYY-MM"));
  const [showManageColumn, setShowManageColumn] = useState(false);
  const [showManageRow, setShowManageRow] = useState(false);
  const [columnDataList, setColumnDataList] = useState([]);
  const [gcOption, setGcOption] = useState([]);

  const [rowDataList, setRowDataList] = useState([]);
  const [columnManageList, setColumnManageList] = useState([]);
  const [rowManageList, setRowManageList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "Dummy",
      text: "COMPOSITION GAS",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "rgb(126, 142, 218)",
        width: "2%",
      },
      formatter: CountIndexRow,
    },
  ]);

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (
      rowIndex == modelDeviceList.length - 1 &&
      dateNow == moment(props.dateSelected).format("YYYY-MM")
    ) {
      style.fontWeight = "bold";
      style.color = "#FFFFFF";
      style.border = "2px solid #FFFFFF";
      // style.opacity = "0.6";
    } else {
      style.color = "white";
    }

    return style;
  };

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  const getColumn = () => post(GET_DT_COMPOSITION_COLUMN, {});
  const getRow = () => post(GET_DT_COMPOSITION_ROW, {});
  const handleAddColumn = () => {
    setColumnManageList(prevent => [
      ...prevent,
      {
        ROW: columnManageList.length + 1,
        PID: "",
        COMPOSITIONCOLUMN_ORDER: columnManageList.length + 1,
        COMPOSITIONCOLUMN_NAME: "",
        SCADATAG_NAME: "",
        GQMSTAG_NAME: "",
        GMDRTAG_NAME: "",
        COMPOSITIONCOLUMN_GCNAME: "",
        COMPOSITIONCOLUMN_TYPE: "",
        COMPOSITIONCOLUMN_SHOW: true,
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 0,
        color: colorOption[0],
        show: { label: "Show", value: 1 },
        source: { label: "Manual", value: 0 },
      },
    ]);
  };
  const handleAddRow = () => {
    setRowManageList(prevent => [
      ...prevent,
      {
        ROW: rowManageList.length + 1,
        PID: "",
        COMPOSITIONROW_ORDER: rowManageList.length + 1,
        COMPOSITIONROW_NAME: "",
        SCADATAG_NAME: "",
        GQMSTAG_NAME: "",
        GMDRTAG_NAME: "",
        QTYPOINT_NAME: "",
        COMPOSITIONROW_DESC: "",
        COMPOSITIONROW_TYPE: 0,
        COMPOSITIONROW_SHOW: true,
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 1,
        qty: [],
        gcType: [],
        color: colorOption[0],
        show: { label: "Show", value: 1 },
        // source:{label:"Manual",value:0}
      },
    ]);
  };
  const handleSaveColumn = async () => {
    function validateDuplicate() {
      let valueArr = columnManageList.map(function (item) {
        return item.COMPOSITIONCOLUMN_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Column name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !columnManageList.some(
          row =>
            row.COMPOSITIONCOLUMN_NAME == "" ||
            row.COMPOSITIONCOLUMN_ORDER == ""
        )
      ) {
        let data = [...columnManageList];
        let res = await post(SAVE_DT_COMPOSITION_COLUMN, data);
        if (res.resultCode == 200) {
          fetchData();
          setShowManageColumn(false);
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const handleSaveRow = async () => {
    function validateDuplicate() {
      let valueArr = rowManageList.map(function (item) {
        return item.COMPOSITIONROW_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Row name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !rowManageList.some(
          row => row.COMPOSITIONROW_NAME == "" || row.COMPOSITIONROW_ORDER == ""
        )
      ) {
        let data = [...rowManageList];
        data = data.map(row => ({
          ...row,
          COMPOSITIONROW_DESC: row.gcType.map(gc => gc.label).toString(),
        }));
        let res = await post(SAVE_DT_COMPOSITION_ROW, data);
        if (res.resultCode == 200) {
          fetchData();
          setShowManageRow(false);
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const generateRow = () => {
    let rowData = [
      ...rowDataList
        .filter(obj => obj.COMPOSITIONROW_SHOW == 1)
        .sort((a, b) =>
          a.COMPOSITIONROW_ORDER > b.COMPOSITIONROW_ORDER
            ? 1
            : b.COMPOSITIONROW_ORDER > a.COMPOSITIONROW_ORDER
              ? -1
              : 0
        ),
    ];

    let tempRowData = addFieldToModelDeviceList(rowData);
    if (tempRowData) setModelDeviceList([...tempRowData]);

    // setModelDeviceList([...tempRowData]);
  };

  const formatNumber = (cellContent, row) => {
    return (
      <div>
        {numberFormat(cellContent, 2)}
      </div>
    );
  };
  const SumTotal = () => {
    let fieldNotSum = [
      "ROW",
      "PID",
      "COMPOSITIONROW_ORDER",
      "COMPOSITIONROW_NAME",
      "SCADATAG_NAME",
      "GQMSTAG_NAME",
      "GMDRTAG_NAME",
      "QTYPOINT_NAME",
      "COMPOSITIONROW_DESC",
      "COMPOSITIONROW_TYPE",
      "COMPOSITIONROW_SHOW",
      "PRIORITY_FLAG",
      "STATUS_FLAG",
      "CREATE_USER",
      "CREATE_DATE",
      "UPDATE_USER",
      "UPDATE_DATE",
      "Total",
    ];
    let data = modelDeviceList.map(row => {
      let sumTotal = 0;

      for (const property in row) {
        if (typeof row[property] != "object") {
          // console.log(fieldNotSum.indexOf(property),property)
          if (fieldNotSum.indexOf(property) == -1) {
            sumTotal += parseFloat(row[property]);
          }
        }
      }
      return { ...row, Total: sumTotal };
    });
    setModelDeviceList(data);
  };
  const renderColumn = () => {
    // console.log(columnDataList.map(obj =>console.log(obj.COMPOSITIONCOLUMN_NAME.replaceAll('.', '_')) ))
    setColumnRenderList([
      {
        dataField: "COMPOSITIONROW_NAME",
        text: "COMPOSITION GAS",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "rgb(126, 142, 218)",
          width: "2%",
        },
        style: (cell, row, rowIndex, colIndex) => {
          return {
            backgroundColor: colorOption[row.COMPOSITIONROW_TYPE].label,
            color: "#FFFFFF",
            fontWeight: "bold",
          };
        },
        formatter: (cellContent, row) => {
          // console.log(row)
          let row_name = cellContent;
          if (row.N_DAY < 0) row_name += " (D-" + Math.abs(row.N_DAY) + ")";
          return (
            <>
              {row_name}
            </>
          )
        }

        ,
      },
      ...columnDataList
        .sort((a, b) =>
          a.COMPOSITIONCOLUMN_ORDER > b.COMPOSITIONCOLUMN_ORDER
            ? 1
            : b.COMPOSITIONCOLUMN_ORDER > a.COMPOSITIONCOLUMN_ORDER
              ? -1
              : 0
        )
        .filter(
          obj =>
            obj.COMPOSITIONCOLUMN_SHOW == true ||
            obj.COMPOSITIONCOLUMN_SHOW == "true"
        )
        .map(obj => ({
          dataField: obj.COMPOSITIONCOLUMN_NAME.replaceAll(".", "_"),
          text: obj.COMPOSITIONCOLUMN_NAME,
          headerAlign: "center",
          editable: true,
          align: "center",
          editorStyle: () => {
            return { height: "25px" }
          },
          formatter: formatNumber,
          headerStyle: {
            backgroundColor: colorOption[obj.COMPOSITIONCOLUMN_TYPE].label,
            width: "5%",
          },
          style: { 
            cursor: "pointer" 
          },
          classes: (cell, row, rowIndex, colIndex) => {
            let className = "";
            if (row.STATUS_FLAG != 0) className += "from-source";
            if (row.STATUS_FLAG == 1 || row.STATUS_FLAG == 3)
              className += " pmis";
            return className;
          },
          validator: (newValue, row, column, done) => {
            setTimeout(() => {
              if (isNaN(newValue)) {
                return done({
                  valid: false,
                  message: "Should be numeric",
                });
              }
              return done();
            }, 0);
            return {
              async: true,
            };
          },
        })),
      {
        dataField: "Total",
        text: "Total",
        headerAlign: "center",
        formatter: formatNumber,
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "#556ee6",
          width: "5%",
        },
      },
    ]);
  };
  const handleShowManageColumn = async () => {
    setColumnManageList([]);
    dispatch(loadingAction.showLoading());
    try {
      setShowManageColumn(true);
      let column = await getColumn();
      // console.log(column);
      setColumnManageList(
        column.data.dtGasCompositionColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          color: colorOption[obj.COMPOSITIONCOLUMN_TYPE],
          show:
            obj.COMPOSITIONCOLUMN_SHOW == 1
              ? { label: "Show", value: 1 }
              : { label: "Hide", value: 0 },
          source:
            obj.STATUS_FLAG == 0
              ? { label: "Manual", value: 0 }
              : obj.STATUS_FLAG == 1
                ? { label: "Scada", value: 1 }
                : { label: "Flow Selection", value: 2 },
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }

    dispatch(loadingAction.hideLoading());
  };
  const handleShowManageRow = async () => {
    setRowManageList([]);
    dispatch(loadingAction.showLoading());
    try {
      setShowManageRow(true);
      let row = await getRow();
      // console.log(column);
      setRowManageList(
        row.data.dtGasCompositionRowList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          gcType: obj.COMPOSITIONROW_DESC
            ? gcOption.filter(
              opt =>
                obj.COMPOSITIONROW_DESC.split(",").indexOf(opt.label) >= 0
            )
            : [],
          color: colorOption[obj.COMPOSITIONROW_TYPE],
          show:
            obj.COMPOSITIONROW_SHOW == 1
              ? { label: "Show", value: 1 }
              : { label: "Hide", value: 0 },
          source:
            obj.STATUS_FLAG == 0
              ? { label: "Manual", value: 0 }
              : obj.STATUS_FLAG == 1
                ? { label: "Scada", value: 1 }
                : { label: "Flow Selection", value: 2 },
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }

    dispatch(loadingAction.hideLoading());
  };
  const handleRefreshData = async () => {
    dispatch(loadingAction.showLoading());
    try {

      // console.log(data)
      let res = await post(LOAD_GAS_COMPOSITON, { GAS_DATE: moment(props.dateSelected).format("YYYY-MM-DD") });
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Refresh Success."));
        fetchData();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  }
  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];
      // console.log(modelDeviceList)
      modelDeviceList.map(obj => {
        columnDataList.map(objColumn => {
          data.push({
            ...obj[
            `${objColumn.COMPOSITIONCOLUMN_NAME.replaceAll(".", "_")}__data`
            ],
            GAS_DATA:
              obj[objColumn.COMPOSITIONCOLUMN_NAME.replaceAll(".", "_")],
          });
        });
      });
      // console.log(data)
      let res = await post(SAVE_DT_COMPOSITION, data);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        fetchData();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const handleSaveDataByRow = async row => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];
      console.log(row);
      columnDataList.map(objColumn => {
        data.push({
          ...row[
          `${objColumn.COMPOSITIONCOLUMN_NAME.replaceAll(".", "_")}__data`
          ],
          GAS_DATA: row[objColumn.COMPOSITIONCOLUMN_NAME.replaceAll(".", "_")],
        });
      });
      //   console.log(row);
      //   let res = await post(SAVE_DT_COMPOSITION, data);
      //   if (res.resultCode == 200) {
      //       dispatch(messageAction.showMessage("Save success."));
      //       // fetchData()
      //   }else{
      //       dispatch(messageAction.showMessage(res.resultDescription));
      //     }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const fetchData = async () => {
    dispatch(loadingAction.showLoading());

    try {
      // generateRow();
      let column = await getColumn();
      let row = await getRow();
      setColumnDataList(
        column.data.dtGasCompositionColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
        }))
      );
      setRowDataList(
        row.data.dtGasCompositionRowList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
        }))
      );
      let data = await post(GET_DT_COMPOSITION, {
        GAS_DATE: moment(props.dateSelected).format("YYYY-MM-DD"),
      });
      setDataList(data.data.dtGasCompositionList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const getOption = async () => {
    try {
      let res = await post(GET_GC_GROUP, {});
      setGcOption(
        res.data.gcGroupList
          .map(obj => ({ label: obj.ALIAS_NAME, value: obj.VALUE }))
          .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));

    }
  };
  useEffect(() => {
    generateRow();
  }, [dataList]);
  useEffect(() => {
    getOption();
    fetchData();
  }, [props.dateSelected]);
  useEffect(() => {
    renderColumn();
    if (columnDataList.length > 1) {
      generateRow();
    }
  }, [columnDataList]);
  const addFieldToModelDeviceList = rowList => {
    function sumDataColumn(list) {
      let fieldNotSum = [
        "ROW",
        "PID",
        "COMPOSITIONROW_ORDER",
        "COMPOSITIONROW_NAME",
        "SCADATAG_NAME",
        "GQMSTAG_NAME",
        "GMDRTAG_NAME",
        "QTYPOINT_NAME",
        "COMPOSITIONROW_DESC",
        "COMPOSITIONROW_TYPE",
        "COMPOSITIONROW_SHOW",
        "PRIORITY_FLAG",
        "STATUS_FLAG",
        "CREATE_USER",
        "CREATE_DATE",
        "UPDATE_USER",
        "UPDATE_DATE",
        "Total",
        "N_DAY"
      ];
      let data = list.map(row => {
        let sumTotal = 0;

        for (const property in row) {
          if (typeof row[property] != "object") {
            // console.log(fieldNotSum.indexOf(property),property)
            if (fieldNotSum.indexOf(property) == -1) {
              sumTotal += parseFloat(row[property]);
            }
          }
        }
        return { ...row, Total: sumTotal }; //numberFormat(sumTotal, 2) 
      });
      return data;
    }
    let dataModel = {
      PID: "",
      GAS_DATE: moment(props.dateSelected).format("YYYY-MM-DD"),
      COMPOSITIONROW_PID: "",
      COMPOSITIONROW_ORDER: 0,
      COMPOSITIONROW_NAME: "",
      COMPOSITIONROW_DESC: "",

      COMPOSITIONCOLUMN_PID: "",
      COMPOSITIONCOLUMN_ORDER: 0,
      COMPOSITIONCOLUMN_NAME: "",
      COMPOSITIONCOLUMN_GCNAME: "",
      GMDR_NAME: "",
      GMDR_DATA: 0,
      SCADA_NAME: "",
      SCADA_DATA: 0,
      FLOW_DATA: 0,
      GAS_DATA: 0,
      SOURCE_PID: "",
      SOURCE_NAME: "",
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };
    if (rowList.length > 0) {
      let modelList = [];
      columnDataList.map(objColumn => {
        modelList = rowList.map(obj => {
          let value;
          if (dataList) {
            value = dataList.find(
              valueData =>
                valueData.COMPOSITIONCOLUMN_PID == objColumn.PID &&
                valueData.COMPOSITIONROW_PID == obj.PID
            );
          }

          let total = 0;
          obj[objColumn.COMPOSITIONCOLUMN_NAME.replaceAll(".", "_")] = value
            ? value.GAS_DATA
            : 0;

          obj[
            `${objColumn.COMPOSITIONCOLUMN_NAME.replaceAll(".", "_")}__data`
          ] = {
            ...dataModel,
            ...value,
            COMPOSITIONCOLUMN_PID: objColumn.PID,
            COMPOSITIONCOLUMN_ORDER: objColumn.COMPOSITIONCOLUMN_ORDER,
            COMPOSITIONCOLUMN_NAME: objColumn.COMPOSITIONCOLUMN_NAME,
            COMPOSITIONCOLUMN_GCNAME: objColumn.COMPOSITIONCOLUMN_GCNAME,

            COMPOSITIONROW_PID: obj.PID,
            COMPOSITIONROW_ORDER: obj.COMPOSITIONROW_ORDER,
            COMPOSITIONROW_NAME: obj.COMPOSITIONROW_NAME,
            COMPOSITIONROW_DESC: obj.COMPOSITIONROW_DESC,
          };
          return { ...obj, Total: total };
        });
      });
      modelList = sumDataColumn(modelList);
      return modelList;
      // console.log(modelList)
    }
  };
  const columnOption = {
    menu: (provided, state) => ({
      ...provided,
      width: 270,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#2E3446" : undefined,
      };
    },
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "#2A3042",
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#FFFFFF",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#BFC8E2",
      ":hover": {
        backgroundColor: "#2A3042",
        color: "white",
      },
    }),
  };
  // const SelectQty = (cellContent, row) => {
  //   // console.log(row)
  //   return (
  //     <div>
  //       <Select
  //         value={cellContent}
  //         isClearable={true}
  //         isMulti
  //         onChange={selected => {
  //           setRowManageList(prev => {
  //             return prev.map(obj => {
  //               if (row.ROW == obj.ROW) {
  //                 return {
  //                   ...obj,
  //                   qty: selected,
  //                 };
  //               }
  //               return { ...obj };
  //             });
  //           });
  //         }}
  //         options={qtyOption}
  //         classNamePrefix="select2-selection"
  //         styles={columnOption}
  //       />
  //     </div>
  //   );
  // };
  const PickColorRow = (cellContent, row) => {
    return (
      <SelectColor
        value={cellContent}
        onChange={selected => {
          setRowManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  color: selected,
                  COMPOSITIONROW_TYPE: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const PickColorColumn = (cellContent, row) => {
    return (
      <SelectColor
        value={cellContent}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  color: selected,
                  COMPOSITIONCOLUMN_TYPE: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }
  const SelectShowRow = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Show", value: 1 },
          { label: "Hide", value: 0 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setRowManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  show: selected,
                  COMPOSITIONROW_SHOW: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const SelectGcType = (cellContent, row) => {
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={true}
          isMulti
          onChange={selected => {
            setRowManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    gcType: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={gcOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const SelectShowColumn = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Show", value: 1 },
          { label: "Hide", value: 0 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  show: selected,
                  COMPOSITIONCOLUMN_SHOW: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const rowManage = [
    {
      dataField: "COMPOSITIONROW_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "50px",
        cursor:"pointer",
      },
      type: "number",
    },

    {
      dataField: "COMPOSITIONROW_NAME",
      text: "Column Name",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      style: {
        width: "100px",
      },
    },

    // {
    //   dataField: "gcType",
    //   text: "GC Type",
    //   headerAlign: "center",
    //   sort: true,
    //   editable:false,
    //   // editable: (content, row, rowIndex, columnIndex) => row.PID == "",
    //   align: "center",
    //   style: {
    //     width: "200px",
    //   },
    //   formatter: SelectGcType,
    // },

    // {
    //   dataField: "STATUS_FLAG",
    //   text: "Source",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   editor: {
    //     type: Type.SELECT,
    //     options: [
    //       // {
    //       //   value: 0,
    //       //   label: "Manual",
    //       // },
    //       {
    //         value: 1,
    //         label: "SCADA",
    //       },
    //       // {
    //       //   value: 2,
    //       //   label: "Flow Selection",
    //       // },
    //       {
    //         value: 3,
    //         label: "GMDR",
    //       },
    //     ],
    //   },
    //   formatter: (cell, row, rowIndex) =>
    //     row.STATUS_FLAG == 0
    //       ? "Manual"
    //       : row.STATUS_FLAG == 1
    //       ? "SCADA"
    //       : row.STATUS_FLAG == 2
    //       ? "Flow Selection"
    //       : "GMDR",

    // },
    {
      dataField: "GQMSTAG_NAME",
      text: "GQMS Tag",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "100px",
        cursor:"pointer",
      },
    },
    {
      dataField: "SCADATAG_NAME",
      text: "SCADA Tag",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "100px",
        cursor:"pointer",
      },
    },
    {
      dataField: "N_DAY",
      text: "Day",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      headerStyle: {
        width: "50px",
      },
      style: {
        width: "50px",
        cursor:"pointer",
      },
      type: "number",
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          } else if (newValue > 0) {
            return done({
              valid: false,
              message: "Should be negative value",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
    },
    // {
    //   dataField: "QTYPOINT_NAME",
    //   text: "Quality Point",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    // {
    //   dataField: "GMDRTAG_NAME",
    //   text: "GMDR Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },

    // {
    //   dataField: "qty",
    //   text: "Quality Point",
    //   headerAlign: "center",
    //   sort: false,
    //   editable: false,
    //   align: "center",

    //   style: {
    //     width: "200px",
    //   },
    //   formatter: SelectQty,
    // },
    {
      dataField: "color",
      text: "Color",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "70px",
        cursor:"pointer",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: PickColorRow,
    },
    {
      dataField: "show",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "100px",
        cursor:"pointer",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectShowRow,
    },
    // {
    //   dataField: "ACTION",
    //   isDummyField: true,
    //   text: "Action",
    //   headerAlign: "center",
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   formatter: deleteColumnButton,
    // },
  ];
  const columnManage = [
    {
      dataField: "COMPOSITIONCOLUMN_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "50px",
        cursor:"pointer",
      },
      type: "number",
    },

    {
      dataField: "COMPOSITIONCOLUMN_NAME",
      text: "Column Name",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      sort: true,
      style: {
        width: "100px",
       
      },
    },

    // {
    //   dataField: "GMDRTAG_NAME",
    //   text: "GMDR Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   sort: true,
    // },

    {
      dataField: "COMPOSITIONCOLUMN_GCNAME",
      text: "Description",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "150px",
        cursor:"pointer",
      },
    },
    {
      dataField: "color",
      text: "Color",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "70px",
        cursor:"pointer",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: PickColorColumn,
    },
    {
      dataField: "show",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "100px",
        cursor:"pointer",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectShowColumn,
    },
    // {
    //   dataField: "ACTION",
    //   isDummyField: true,
    //   text: "Action",
    //   headerAlign: "center",
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   formatter: deleteColumnButton,
    // },
  ];
  return (
    <div>
      <Col sm="12">
        <div className="d-flex justify-content-end">
          {permission.mMIM && (
            <>
              <button
                type="button"
                className="btn btn-primary me-2"
                onClick={() => handleShowManageColumn()}
              >
                <i className="bx bx-columns"></i>&nbsp; Manage Column Gas
                Composition
              </button>
              <button
                type="button"
                className="btn btn-primary me-2"
                onClick={() => handleShowManageRow()}
              >
                <i className="bx bx-columns"></i>&nbsp; Manage Row Gas Composition
              </button>
            </>
          )}

          {permission.eGAC && (
            <>
              <button
                type="button"
                className="btn btn-info me-2"
                // onClick={() => handleRefreshData()}
                onClick={() => {
                  dispatch(
                    confirmAction.showConfirm(
                      "ต้องการ Refresh หรือไม่ ? หากต้องการ Refresh ระบบจะทำการล้างค่าปัจจุบัน",
                      () => {
                        handleRefreshData()
                      }
                    )
                  );
                }}
              >
                <i className="mdi mdi-cloud-refresh fa-lg"></i>&nbsp; Refresh Manual
              </button>
              <button
                type="button"
                className="btn btn-success me-2"
                onClick={handleSaveData}
              >
                <i className="bx bx-save"></i>&nbsp; Save
              </button>
            </>
          )}
        </div>
        <div className="mt-2">
          <BootstrapTable
            id="composition-tab-table"
            keyField="PID"
            data={modelDeviceList}
            columns={columnRenderList}
            rowStyle={rowStyleFontWhite}
            headerClasses="header-style"
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              onStartEdit: (oldValue, newValue, row, column) => {
                $("#composition-tab-table .form-control.editor.edit-text").bind(
                  "enterKey",
                  function (e) {
                    let cell = $(this).parent().next();
                    setTimeout(() => {
                      cell.click();
                    }, 50);
                  }
                );
                $(
                  "#composition-tab-table .form-control.editor.edit-text"
                ).keypress(function (e) {
                  if (e.keyCode == 13) {
                    $(this).trigger("enterKey");
                  }
                });
              },
              afterSaveCell: (oldValue, newValue, row, column) => {
                SumTotal();
                // console.log(oldValue,newValue, row, column)
              },
            })}
          />
        </div>
      </Col>
      <Modal size="xl" isOpen={showManageColumn} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Column Gas Composition</h5>

          <button
            type="button"
            onClick={() => {
              setShowManageColumn(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <BootstrapTable
            id="collumn-composition-table"
            keyField="ROW"
            data={columnManageList}
            columns={columnManage}
            rowStyle={rowStyleFontWhite}
            headerClasses="header-style"
            defaultSorted={defaultSortColumnManage}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(columnDataList);
              },
            })}
          />
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddColumn()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveColumn()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageColumn(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
      <Modal size="xl" isOpen={showManageRow} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Row Gas Composition</h5>

          <button
            type="button"
            onClick={() => {
              setShowManageRow(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <BootstrapTable
            id="row-composition-table"
            keyField="ROW"
            wrapperClasses="table-on-scroll"
            data={rowManageList}
            columns={rowManage}
            rowStyle={rowStyleFontWhite}
            headerClasses="header-style"
            defaultSorted={defaultSortRowManage}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(columnDataList);
              },
            })}
          />
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddRow()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveRow()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageRow(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
const defaultSortColumnManage = [
  {
    dataField: "COMPOSITIONCOLUMN_ORDER",
    order: "asc", // or desc
  },
];
const defaultSortRowManage = [
  {
    dataField: "COMPOSITIONROW_ORDER",
    order: "asc", // or desc
  },
];
export default GasComposition;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn
const deleteColumnButton = (cell, row) => (
  <OverButton
    onClick={() => {
      // onDelete(row);
    }}
    color="danger"
    icon="fas fa-trash-alt"
    label="Delete"
  />
);

GasComposition.propTypes = {
  dateSelected: PropTypes.any,
};
